import { useEffect } from 'react';
import ReactGA from 'react-ga4';

// Initialize Google Analytics
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID;

export const initGA = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GA_MEASUREMENT_ID);
    console.log('Google Analytics initialized');
  } else {
    console.log('Google Analytics not configured. Add your GA4 Measurement ID to .env');
  }
};

export const logPageView = () => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  }
};

export const logEvent = (category, action, label) => {
  if (GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    ReactGA.event({
      category,
      action,
      label
    });
  }
};

// Hook for tracking page views
export const usePageTracking = () => {
  useEffect(() => {
    logPageView();
  }, []);
};
